import { useState } from 'react'
import { SelectField } from '@/components/common/input/SelectField'
// import { SelectChangeEvent } from "@mui/material";
import { useRouteQuery } from '@/hooks'

export function TableLimit() {
  const { updateQuery, searchQuery } = useRouteQuery()
  const [perPage, setPerPage] = useState(10)

  // const onChange = (event: SelectChangeEvent<unknown>) => {
  //   setValue(event.target.value as number)
  // }

  useEffect(() => {
    const per = searchQuery.get('perPage') || 10

    setPerPage(Number(per))
  }, [searchQuery])

  return (
    <SelectField
      options={[
        { label: '10', value: 10 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: '100', value: 100 }
      ]}
      value={perPage}
      onChange={e => updateQuery({ perPage: Number(e.target.value), page: undefined })}
    />
  )
}
